import { CardModalView, ViewBody } from 'components/Sidebar'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import React, { useCallback } from 'react'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  ButtonGroup,
} from 'react-bootstrap'
import { Formik } from 'formik'
import Button from 'components/Button'
import requestRemoveCardBlocker from 'store/sagas/requestRemoveCardBlocker'
import CardBlocker from 'components/CardBlocker'

type Props = LeftSidebarProps & {
  cardBlockerId: number
}

const UnblockCard: React.FC<Props> = ({
  leftSidebar,
  cardBlockerId,
}) => {
  const dispatch = useDispatch()

  const cardBlocker = useSelector<any, any>(state => state.kanbo.cardBlockers.byId[cardBlockerId])
  const blocker = useSelector<any, any>(state => state.kanbo.blockers.byId[cardBlocker?.blockerId])

  const close = useCallback(() => {
    leftSidebar.pop()
  }, [])

  return (
    <CardModalView
      title={<FormattedMessage id='BLOCKERS_CARD_UNBLOCK_HEADER' />}
    >
      <ViewBody>
        <ControlLabel><FormattedMessage id='BLOCKERS_CARD_UNBLOCK_BLOCKER' /></ControlLabel>
      </ViewBody>
      {(cardBlocker && blocker) &&
        <CardBlocker
          name={blocker.name}
          description={blocker.description}
          creationDate={cardBlocker.creationDate}
          createdBy={cardBlocker.createdBy}
          reason={cardBlocker.reason}
          userId={cardBlocker.userId}
        />
      }
      <ViewBody>
        <Formik
          initialValues={{
            reason: '',
          }}
          onSubmit={({ reason }) => {
            dispatch(requestRemoveCardBlocker({
              cardBlockerId,
              reason,
            }))

            close()
          }}
        >
          {({ handleSubmit, handleChange, handleBlur, values, isSubmitting }) => (
            <form onSubmit={handleSubmit}>
                <FormGroup>
                  <ControlLabel><FormattedMessage id='BLOCKERS_CARD_UNBLOCK_REASON' /></ControlLabel>
                  <FormattedMessage id='BLOCKERS_CARD_UNBLOCK_REASON_PLACEHOLDER'>
                    {formattedMessage =>
                      <FormControl
                        autoFocus
                        type='text'
                        name='reason'
                        value={values.reason}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder={formattedMessage}
                      />
                    }
                  </FormattedMessage>
                </FormGroup>
                <ButtonGroup>
                  <Button type='submit' bsStyle='primary' disabled={isSubmitting}>
                    <FormattedMessage id='BLOCKERS_CARD_UNBLOCK' />
                  </Button>
                  <Button onClick={close}><FormattedMessage id='CANCEL' /></Button>
                </ButtonGroup>
            </form>
          )}
        </Formik>
      </ViewBody>
    </CardModalView>
  )
}

export default withLeftSidebar(UnblockCard)